import { useDonationApi } from "../api/DonationApiClient";
import { DonationFrontendService } from "../services/DonationFrontendService";

export const useDonationService = (): DonationFrontendService =>
  new DonationFrontendService(useDonationApi());
